import { Tooltip } from 'antd';
import React from 'react';
import { formatNumber } from '../../../util/varibles/global';

interface IProps {
    value?: number
    total?: number
    valueClassName?: string
    layout?: 'horizontal' | 'vertical'
    label?: string
    showPercent?: boolean
}

const LAYOUT_CONFIG = {
    horizontal: {
        containerClassName: 'items-center gap-[10px]',
        labelClassName: 'whitespace-nowrap text-comment',
        labelSuffix: ':',
        valueClassName: 'font-[600]'
    },
    vertical: {
        containerClassName: 'flex-col items-center',
        labelClassName: 'whitespace-nowrap text-comment font-[400]',
        labelSuffix: '',
        valueClassName: 'leading-[22px] font-[400]'
    }
} as const;

const DeadFish: React.FC<IProps> = ({
    value,
    total,
    valueClassName,
    layout = 'horizontal',
    label = 'Dead fish',
    showPercent = true
}) => {
    const layoutConfig = LAYOUT_CONFIG[layout];
    const displayValue = typeof value === 'number' ? formatNumber(value) : '-';
    const percent = typeof value === 'number' && typeof total === 'number' && total > 0
        ? Math.round(value / total * 10000) / 100
        : null;

    return <div className={`flex text-[15px] ${layoutConfig.containerClassName}`}>
        <span className={layoutConfig.labelClassName}>{label}{layoutConfig.labelSuffix}</span>
        <span className={[
            'whitespace-nowrap',
            layout === 'vertical' ? 'block' : 'inline-block',
            valueClassName || '',
            layoutConfig.valueClassName
        ].join(' ')}>
            <Tooltip title='Dead fish'>
                <span className='inline-flex w-fit items-center whitespace-nowrap'>
                {displayValue}{showPercent && percent !== null && ` (${formatNumber(percent)}%)`}
                </span>
            </Tooltip>
        </span>
    </div>;
};

export default DeadFish;
